import { Http } from "../Http";
import { AxiosPromise } from "axios";
import { getUserAccessToken } from "../selectors/Accounts";
import { exceptionHandler } from "../../pages/common/functions";

export default class PromiseLandService {
	public static promiseLandSave(input: any) {
		return input?.contextualMedia?.mediaItemId >= 0
			? Http.axios()
					.put("/api/ContextualMedia/update", input, {
						headers: { Authorization: getUserAccessToken() },
					})
					.then((res: any) => {
						return res;
					})
					.catch((e: any) => {
						return e.response;
					})
			: Http.axios()
					.post("/api/ContextualMedia/add", input, {
						headers: { Authorization: getUserAccessToken() },
					})
					.then((res: any) => {
						return res;
					})
					.catch((e: any) => {
						return e.response;
					});
	}

	public static promiseLandGetByFilter(input: any) {
		return Http.axios()
			.post("/api/ContextualMedia/GetAllMediaItems", input, {
				headers: { Authorization: getUserAccessToken() },
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static promiseLandGetDetail(id: any) {
		return Http.axios()
			.get("/api/ContextualMedia/" + id, {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static promiseLandGetAllBooks() {
		return Http.axios()
			.get("/api/ContextualMedia/getallbooks", {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static promiseLandGenerateSASToken() {
		return (
			Http.axios()
				.get("/api/ContextualMedia/generate-sas-token", {
					headers: { Authorization: getUserAccessToken() },
				})
				.then((res: any) => {
					var response = exceptionHandler(res);
					return response?.data;
				})
				.catch((e: { response: any }) => {
					return e.response;
				}) as AxiosPromise<any>
		);
	}

	public static promiseLandDelete(input: any) {
		return Http.axios()
			.delete(`${!input.videoUrl ? `/api/ContextualMedia/delete/${input}` : `/api/ContextualMedia/delete/${input.id}?videoUrl=${input?.videoUrl}`}`, {
				headers: { Authorization: getUserAccessToken() },
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static getCategoriesApi() {
		return (
			Http.axios()
				.get("/api/Categories/GetAvailableCategories", {
					headers: { Authorization: getUserAccessToken() },
				})
				.then((res: any) => {
					var response = exceptionHandler(res);
					return response?.data;
				})
				.catch((e: { response: any }) => {
					return e.response;
				}) as AxiosPromise<any>
		);
	}
}
